import React from "react";
import RequestDetailsGrid from "./RequestDetailsGrid";
import { useTranslate } from "src/locales";
import type { RequestDetailRow } from "../types";

interface OutOfRequestServicesGridProps {
  rows: RequestDetailRow[];
  loading?: boolean;
}

export default function OutOfRequestServicesGrid({
  rows,
  loading = false,
}: OutOfRequestServicesGridProps) {
  const { t } = useTranslate();

  return (
    <RequestDetailsGrid
      rows={rows}
      loading={loading}
      menuVariant="out-of-request"
      title={t("request-list.out-of-request-services", "default", {
        defaultValue: "İstek Dışı Hizmetler",
      })}
    />
  );
}
